
<div>
    <p class="admin-ps"><b>Add an override.</b></p>
    
    <div class="admin-ps">
        <div class="row admin-row-ip">
          <div class="col-lg-2 admin-width">
            <label class="admin-center">Description</label><br>
            <input type="text">
          </div>
          <div class="col-lg-2 admin-width">
            <label class="admin-center">VIN</label><br>
            <input type="text">
          </div>
          <div class="col-lg-2 admin-width admin-col-radio">
            <label class="admin-center">Once Always</label><br>
            <input type="radio" class="admin-radio1">
            <input type="radio" class="admin-radio2">
          </div>
          <div class="col-lg-2 admin-width admin-dropdown">
            <label class="admin-center">Call Type</label><br>
            <select >
                <option value="REPAIR_AND_POST_REPAIR" class="admin-add-btn-col">REPAIR_AND_POST_REPAIR</option>
                <option value="DIAGNOSTIC" class="admin-add-btn-col">DIAGNOSTIC</option>
            </select>
          </div>
          <div class="col-lg-2 admin-width admin-radio2">
            <label class="admin-center">Upload XML</label><br>
            <textarea name="uploadXML" cols="25" rows="5"></textarea>
          </div>
          <div class="col-lg-2 admin-add-button-target">
            <label class="admin-center"></label><br>
            <input class="admin-add-btn admin-add-btn-col" type="submit" name="add" value="Add">
          </div>
          
       </div>
    </div>


    <table class="table table-hover admin-table">
        <thead  class="admin-head">
          <tr>
            <th class="admin-tab-header-te-override"> <i class="fas fa-triangle"></i>
                
                VIN</th>
            <th class="admin-tab-header-te-override">Description</th>
            <th class="admin-tab-header-te-override"> Call Type</th>
            <th class="admin-tab-header-te-override">Enabled</th>
            <th class="admin-tab-header-te-override"></th>
            <th ></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td >WF0EXXWPCEET13829</td>
            <td >DipenR test</td>
            <td >DIAGNOSTIC</td>
            <td >false</td>
            <td>
                <form action="/action_page.php">
                    <input type="file" id="myFile" name="filename">
                  </form>
            </td>
            <td>
             <input  type="submit" name="uploadXml" value="Upload XML">&nbsp;
             <input  type="submit"name="Download" value="Download">&nbsp;
             <input type="submit"name="Enable" value="Enable" >   &nbsp;
             <input  type="submit" name="Delete" value="Delete">
            </td>
          </tr>
          <tr>
            <td >WF0EXXWPCEET13829</td>
            <td >DipenR test</td>
            <td >DIAGNOSTIC</td>
            <td >false</td>
            <td>
                <form action="/action_page.php">
                    <input type="file" id="myFile" name="filename">
                  </form>
            </td>
            <td>
             <input  type="submit" name="uploadXml" value="Upload XML">&nbsp;
             <input  type="submit"name="Download" value="Download">&nbsp;
             <input type="submit"name="Enable" value="Enable" >   &nbsp;
             <input  type="submit" name="Delete" value="Delete">
            </td>
          </tr>
          <tr>
            <td >WF0EXXWPCEET13829</td>
            <td >DipenR test</td>
            <td >DIAGNOSTIC</td>
            <td >false</td>
            <td>
                <form action="/action_page.php">
                    <input type="file" id="myFile" name="filename">
                  </form>
            </td>
            <td>
             <input  type="submit" name="uploadXml" value="Upload XML">&nbsp;
             <input  type="submit"name="Download" value="Download">&nbsp;
             <input type="submit"name="Enable" value="Enable" >   &nbsp;
             <input  type="submit" name="Delete" value="Delete">
            </td>
          </tr>
        </tbody>
      </table>
    </div>